import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter, useHistory } from 'react-router-dom';
import { withApollo, graphql } from 'react-apollo';

import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import ErrorView from '../../../../components/global/ErrorView';
import { MeForPurchasedEvents } from '../../../../graphql/queries/events';
import { getDefaultProRoleFromAccount } from '../../../../util/account';
import { getRoleBasename } from '../../../../util/role-definitions';
import { isWeddingsContent } from '../../../../util/album';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
  }),
  purchasedEvent: PropTypes.shape({
    id: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

const PurchasedEventRedirect = ({ purchasedEvent, loading, user }) => {
  const history = useHistory();

  const purchasedEventRedirect = () => {
    const role = getDefaultProRoleFromAccount(user);
    const basename = getRoleBasename(role);
    if (purchasedEvent.album_folder) {
      // Case of a purchased event that has been redeemed.
      history.push(
        `/app/${basename}/folders/${purchasedEvent.album_folder.id}`,
      );

      return;
    }

    if (
      // Weddings
      isWeddingsContent(purchasedEvent)
    ) {
      history.push(
        `/app/${basename}/albums/create?eventType=WEDDING&purchasedEventId=${purchasedEvent.id}`,
      );

      return;
    }

    history.push({
      pathname: '/error',
      state: {
        error: 'This link is no longer valid.',
      },
    });
  };

  useEffect(() => {
    if (purchasedEvent) {
      purchasedEventRedirect();
    }
  }, [purchasedEvent]);

  if (!loading && !purchasedEvent) {
    return (
      <ErrorView
        location={{
          state: {
            error: 'We could not find any purchased event with this ID',
          },
        }}
      />
    );
  }

  return <FullScreenLoader />;
};

PurchasedEventRedirect.propTypes = propTypes;

export { PurchasedEventRedirect as AlbumFolderLinkRequestRedirectComp };

const withMeForPurchasedEvents = graphql(MeForPurchasedEvents, {
  options: ({ match }) => ({
    variables: {
      purchased_event_id: match.params.purchasedEventId,
    },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data: { me, loading } }) => ({
    loading,
    user: me,
    purchasedEvent: me?.purchased_events?.records?.[0],
  }),
});

export default compose(
  withApollo,
  withRouter,
  withMeForPurchasedEvents,
)(PurchasedEventRedirect);
